/**!
 * Created by Leonardo Cheslacki on 18/10/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StageMemory extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            checked: [],
            disabled_memory: false,
            disabled_back: false
        };

        this.$stage = [];

        this.$length = 0;

        this.$current_frame = 1;

        this.$start_frame = 1;

        this.$end_frame = 8;

        this.$countDownMomentControll = null;

        _this = this;
    };

    $functions = {

        handleNext: function () {
            let
                item = _this.randomArrayNoRepeat(_this.$stage),
                frame = _this.verifyField(item, 'frame');

            if (frame) {
                _this.$current_frame = frame;
            } else {
                _this.$current_frame = _this.$end_frame;
            }

            _this.$length = 0;
            _this.getFrame().gotoAndPlay('complete');
        },

        handleBack: function () {
            if (!_this.state.disabled_back) {
                _this.$current_frame = 1;
                _this.getFrame().gotoAndPlay('complete');
            }
        },

        /**
         *
         * @param event
         * @param button
         * @param answers
         */
        handleButtonAnswer: function (event, {button, answers}) {
            const
                {delay, delay_next} = _this.props,
                _this_current = _this.get(),
                occ = `occ_pop_up_next_${_this.padWithLeadingZeros(_this.$current_frame, 2)}`,
                btn_next = _this.verifyField(_this_current, `${occ}.btn_next`),
                occ_progress = _this.verifyField(_this_current, `${occ}.occ_progress`),
                occ_text = _this.verifyField(_this_current, `${occ}.occ_text`),
                total = _this.padWithLeadingZeros(_this.props.stage.length, 2),
                current = _this.padWithLeadingZeros(_this.props.stage.length - _this.$stage.length, 2),
                handle_name_next = _this.toHandleName(occ, 'memory');

            occ_progress.font = "bold 35px 'CoHeadline'";

            _this[handle_name_next] && btn_next.off('mousedown', _this[handle_name_next]);
            _this[handle_name_next] = btn_next.on('mousedown', () => {
                _this.clearThrottle('throttle-next');
                _this.effectFadeOut(_this_current, occ, _this.$functions.handleNext);
            });

            if (!_this.state.disabled_memory) {
                let checked = _this.getStateOccurrence(button, 'checked');

                if (!checked) {
                    _this.setStateOccurrence(button, {checked: true});
                    button.gotoAndPlay('start');
                }

                if (_this.state.checked.length < 2 && !_this.getStateOccurrence(button, 'disabled')) {
                    _this.setState({..._this.state, checked: [..._this.state.checked, button]}, () => {
                        if (_this.state.checked.length === 2) {
                            _this.state.disabled_memory = true;

                            let
                                button_left = _this.state.checked[0],
                                button_right = _this.state.checked[1],
                                number_left = _this.toNumber(button_left.name),
                                number_right = _this.toNumber(button_right.name),
                                length = answers.length,
                                check = false;

                            for (let i = 0; length > i; i++) {
                                if (_this.inArray(answers[i], number_left) && _this.inArray(answers[i], number_right)) {
                                    _this.setStateOccurrence(button_left, {disabled: true});
                                    _this.setStateOccurrence(button_right, {disabled: true});
                                    _this.$length++;
                                    check = true;
                                }

                                if (_this.endFor(length, i)) {
                                    if (!check) {
                                        _this.throttle('throttle-reset-answer', () => {
                                            if (!_this.getStateOccurrence(button_left, 'disabled')) {
                                                _this.setStateOccurrence(button_left, {checked: false});
                                                button_left.gotoAndPlay('end');
                                            }

                                            if (!_this.getStateOccurrence(button_right, 'disabled')) {
                                                _this.setStateOccurrence(button_right, {checked: false});
                                                button_right.gotoAndPlay('end');
                                            }
                                            _this.state.disabled_memory = false;
                                        }, delay);
                                    } else {
                                        _this.state.disabled_memory = false;
                                    }

                                    if (length === _this.$length) {
                                        _this.$countDownMomentControll.pause();

                                        occ_progress.text = `${current}/${total}`;

                                        occ_text.gotoAndStop(`frame${current}`);

                                        _this.effectFadeIn(_this_current, occ);

                                        _this.throttle('throttle-next', () => {
                                            _this.effectFadeOut(_this_current, occ, _this.$functions.handleNext);
                                        }, delay_next);
                                    }

                                    _this.setState({..._this.state, checked: []});
                                }
                            }
                        }
                    });
                }
            } else {
                return _this.stopPropagation(event);
            }
        }
    };

    getAnswers = () => {
        const
            {stage} = this.props,
            object = stage.find(({frame}) => (frame === this.$current_frame));

        return this.verifyField(object, 'answers');
    };

    startMemory = () => {
        const {
            delay,
            delay_sleep,
            delay_start,
            time_out_count_down,
            time_out_moment,
            stage
        } = this.props;

        this.$stage = [...stage];

        const
            _this_current = this.get(),
            occ_time_out = this.verifyField(_this_current, 'occ_time_out');

        occ_time_out && (occ_time_out.font = "bold 50px 'CoHeadline'");

        this.main.on('animate_end', () => {

            this.clearCountDownMoment('count-down-moment-back');

            this.gotoAndStopFrame(_this_current, this.$current_frame);

            const _this_frame = this.getFrame();

            _this_frame.gotoAndPlay('start');

            const
                buttons = this.verifyField(_this_frame, 'occ_memory.children'),
                answers = this.getAnswers();

            if (this.$current_frame === this.$start_frame) {
                this.$stage = [...this.props.stage];
            }

            if (this.isArrayIf(buttons) && this.isArrayIf(answers)) {
                const
                    occ = `occ_pop_up_back_${_this.padWithLeadingZeros(_this.$current_frame, 2)}`,
                    btn_back = _this.verifyField(_this_current, `${occ}.btn_back`),
                    handle_name_back = this.toHandleName(occ, 'memory');

                this[handle_name_back] && btn_back.off('mousedown', this[handle_name_back]);
                this[handle_name_back] = btn_back.on('mousedown', () => {
                    this.clearThrottle('throttle-back');
                    this.effectFadeOut(_this_current, occ, () => {
                        this.state.disabled_memory = false;
                        this.state.disabled_back = false;
                        this.$functions.handleBack();
                    });
                });

                occ_time_out.text = time_out_moment.substring(3);

                for (let button of buttons) {
                    let
                        occ_button = `${this.$current_frame}${button.name}`,
                        handle_name = this.toHandleName(occ_button, 'answer'),
                        number = this.toNumber(button.name);

                    button.cursor = 'pointer';

                    button.gotoAndPlay('start');

                    this[handle_name] && button.off('mousedown', this[handle_name]);

                    this.throttle(`throttle-preview-${occ_button}`, () => {
                        button.gotoAndPlay('end');

                        this.setStateOccurrence(button, {checked: false, disabled: false});

                        this[handle_name] = button.on('mousedown', this.$functions.handleButtonAnswer, false, false, {
                            button: button,
                            answers: answers
                        });

                        this.throttle('throttle-start', () => {
                            this.$countDownMomentControll = this.countDownMoment('count-down-moment-back', delay, time_out_moment, (time) => {
                                occ_time_out.text = time;
                            }, () => {
                                this.state.disabled_memory = true;
                                this.state.disabled_back = true;

                                let occ = `occ_pop_up_back_${_this.padWithLeadingZeros(_this.$current_frame, 2)}`;

                                this.effectFadeIn(_this_current, occ);

                                this.throttle('throttle-back', () => {
                                    this.effectFadeOut(_this_current, occ, () => {
                                        this.state.disabled_memory = false;
                                        this.state.disabled_back = false;
                                        this.$functions.handleBack();
                                    });
                                }, delay_start);
                            });
                        }, (number * delay_sleep) + delay);
                    }, (number * delay_sleep) + delay_start);
                }
            }

            if (this.$current_frame === 2) {
                let {btn_start} = _this_frame;

                this._handleStart && btn_start.off('mousedown', this._handleStart);
                this._handleStart = btn_start.on('mousedown', this.$functions.handleNext);
            }

            (this.$current_frame === this.$end_frame) && this.throttle('throttle-back', this.$functions.handleBack, time_out_count_down);
        });
    };

    /**
     *
     */
    initMemory = () => {
        const {totalFrames, btn_init, btn_back} = this.get();

        this.$end_frame = (totalFrames - 1);

        let handle_name_init = this.toHandleName('init', 'memory');

        this[handle_name_init] && btn_init.off('mousedown', this[handle_name_init]);
        this[handle_name_init] = btn_init.on('mousedown', () => {
            this.$current_frame = 2;
            this.getFrame().gotoAndPlay('complete');
        });

        let handle_name_back = this.toHandleName('back', 'memory');

        this[handle_name_back] && btn_back.off('mousedown', this[handle_name_back]);
        this[handle_name_back] = btn_back.on('mousedown', this.$functions.handleBack);

        this.startMemory();
    };
}

/**
 *
 * @type {{}}
 */
StageMemory.propTypes = {
    delay: PropTypes.number,
    delay_sleep: PropTypes.number,
    delay_start: PropTypes.number,
    delay_next: PropTypes.number,
    time_out_count_down: PropTypes.number,
    time_out_moment: PropTypes.string,
    stage: PropTypes.array
};

/**
 *
 * @type {{}}
 */
StageMemory.defaultProps = {
    delay: 1000,
    delay_sleep: 100,
    delay_start: 5000,
    delay_next: 10000,
    time_out_count_down: 8000,
    time_out_moment: '00:00:30',
    stage: [
        {
            frame: 3,
            answers: [
                [1, 2],
                [3, 4],
                [5, 6]
            ]
        },
        {
            frame: 4,
            answers: [
                [1, 6],
                [2, 5],
                [3, 4]
            ]
        },
        {
            frame: 5,
            answers: [
                [1, 2],
                [3, 4],
                [5, 6]
            ]
        },
        {
            frame: 6,
            answers: [
                [1, 5],
                [2, 6],
                [3, 4]
            ]
        },
        {
            frame: 7,
            answers: [
                [1, 2],
                [3, 4],
                [5, 6]
            ]
        }
    ]
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageMemory, {className: 'StageMemory'});
